module.exports = __webpack_public_path__ + "img/icon_city5.e797ea63.png";